'use client';

import { useEffect } from 'react';

const isDevelopment = process.env.NEXT_PUBLIC_APP_ENV === 'development';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Application error:', error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">
            Something went wrong
          </h1>

          {isDevelopment ? (
            <div className="space-y-4">
              <div className="bg-red-50 border border-red-200 rounded-md p-4">
                <h2 className="text-lg font-semibold text-red-800 mb-2">
                  {error.name}: {error.message}
                </h2>
                {error.digest && (
                  <p className="text-sm text-red-600 mb-2">
                    Digest: {error.digest}
                  </p>
                )}
                {error.stack && (
                  <pre className="text-xs text-red-700 overflow-x-auto whitespace-pre-wrap bg-red-100 p-3 rounded">
                    {error.stack}
                  </pre>
                )}
              </div>
              <p className="text-sm text-gray-500">
                Debug mode enabled (APP_ENV=development)
              </p>
            </div>
          ) : (
            <p className="text-gray-600 mb-6">
              An unexpected error occurred. Please try again or contact support if the problem persists.
            </p>
          )}

          <div className="mt-6 flex gap-4">
            <button
              onClick={reset}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
            >
              Try again
            </button>
            <button
              onClick={() => window.location.href = '/'}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
            >
              Go home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
